import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../styles/Contact.css";

const Contact = () => {
  const [status, setStatus] = useState({ state: "idle", message: "" });

  const sendForm = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", message: "" });

    const payload = {
      nombre: e.target.nombre.value,
      contacto: e.target.contacto.value,
      mensaje: e.target.mensaje.value,
      motivo: e.target.motivo.value || null,
      privacyAccepted: e.target.privacyAccepted.checked,
    };

    try {
      const res = await fetch("/api/alaiak/contact", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errorData = await res.json().catch(() => null);

        setStatus({
          state: "error",
          message:
            errorData?.detail || "Errorea mezua bidaltzean. Saiatu berriro mesedez.",
        });
        return;
      }

      setStatus({
        state: "success",
        message: "Mezua ondo bidali da! Eskerrik asko 😊",
      });
      e.target.reset();
    } catch (err) {
      setStatus({
        state: "error",
        message: "Ezin izan da konektatu. Saiatu berriro mesedez.",
      });
    }
  };

  return (
    <div className="contact-container">
      <div className="contact-header">
        <h1>Alaiak-ekin kontaktatu nahi duzu?</h1>
        <p className="contact-subtitle">
          Ekitaldi ezberdinetan jarduten dugu.
          <br />
          Idatzi iezaguzu, azkar erantzuten dugu eta!
        </p>
      </div>

      <div className="quick-actions">
        <a
          href="mailto:soinulariakmungia@alaiak.eus"
          className="btn btn--secondary btn--large"
        >
          <span>✉️</span> Emaila
        </a>
      </div>

      <div className="form-section">
        <p className="form-intro">Edo deskribatu zure ideiak konpromiso gabe:</p>

        <form className="contact-form" onSubmit={sendForm}>
          <div className="form-group">
            <label htmlFor="nombre">Izena *</label>
            <input type="text" id="nombre" name="nombre" required />
          </div>

          <div className="form-group">
            <label htmlFor="contacto">Emaila edo telefonoa *</label>
            <input type="text" id="contacto" name="contacto" required />
          </div>

          <div className="form-group">
            <label htmlFor="mensaje">Mezua *</label>
            <textarea id="mensaje" name="mensaje" rows="4" required />
          </div>

          <div className="form-group">
            <label htmlFor="motivo">Zein motako ekitaldia?</label>
            <select id="motivo" name="motivo">
              <option value="">Hautatu aukera bat</option>
              <option value="ekitaldia">Ekitaldia</option>
              <option value="informazioa">Informazioa</option>
              <option value="bestea">Bestea</option>
            </select>
          </div>

          <div className="form-checkbox">
            <label htmlFor="privacyAccepted" className="checkbox-label">
              <input
                type="checkbox"
                id="privacyAccepted"
                name="privacyAccepted"
                required
              />
              <span>
                <Link to="/privacy-policy">Pribatutasun-politika</Link> irakurri
                eta onartzen dut. *
              </span>
            </label>
          </div>

          <button
            type="submit"
            className="btn btn--primary btn--large"
            disabled={status.state === "loading"}
          >
            {status.state === "loading" ? "Bidaltzen..." : "Bidali mezua"}
          </button>

          {status.state !== "idle" && (
            <p style={{ marginTop: 12 }}>{status.message}</p>
          )}
        </form>
      </div>

      <div className="trust-message">
        <p>
          ✓ 24-48 ordutan erantzuten dugu. Ez ditugu zure datuak partekatzen.
          Sare sozialetan ere aurkitu gaitzakezue.
        </p>
      </div>
    </div>
  );
};

export default Contact;